export default "__VITE_ASSET__CrbFOH$a__"